
export const name = "livechat-unboxing-ui";
export const version = "dev";
